var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigcontact8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_6608)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.625,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17.9658,
    y1: 120.093,
    x2: 17.9658,
    y2: -21.4222,
    stroke: "url(#paint0_linear_75_6608)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.9658,
    y1: 120.093,
    x2: 52.9658,
    y2: -21.4222,
    stroke: "url(#paint1_linear_75_6608)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.9658,
    y1: 120.093,
    x2: 88.9658,
    y2: -21.4222,
    stroke: "url(#paint2_linear_75_6608)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.966,
    y1: 120.093,
    x2: 124.966,
    y2: -21.4222,
    stroke: "url(#paint3_linear_75_6608)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.966,
    y1: 120.093,
    x2: 160.966,
    y2: -21.4222,
    stroke: "url(#paint4_linear_75_6608)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.966,
    y1: 120.093,
    x2: 195.966,
    y2: -21.4222,
    stroke: "url(#paint5_linear_75_6608)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.966,
    y1: 120.093,
    x2: 231.966,
    y2: -21.4222,
    stroke: "url(#paint6_linear_75_6608)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 18.954,
    x2: 258.387,
    y2: 18.954,
    stroke: "url(#paint7_linear_75_6608)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 77.954,
    x2: 258.387,
    y2: 77.954,
    stroke: "url(#paint8_linear_75_6608)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 47.954,
    x2: 258.387,
    y2: 47.954,
    stroke: "url(#paint9_linear_75_6608)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17.125,
    width: 87,
    height: 87,
    rx: 43.5,
    fill: "url(#paint10_linear_75_6608)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_75_6608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1514 70.7592C44.1514 70.0071 44.761 69.3975 45.5131 69.3975H70.0247C70.7768 69.3975 71.3865 70.0071 71.3865 70.7592C71.3865 71.5113 70.7768 72.121 70.0247 72.121H45.5131C44.761 72.121 44.1514 71.5113 44.1514 70.7592ZM46.8749 59.8652C46.8749 59.1131 47.4846 58.5034 48.2366 58.5034C48.9887 58.5034 49.5984 59.1131 49.5984 59.8652V66.674C49.5984 67.426 48.9887 68.0357 48.2366 68.0357C47.4846 68.0357 46.8749 67.426 46.8749 66.674V59.8652ZM53.6837 59.8652C53.6837 59.1131 54.2933 58.5034 55.0454 58.5034C55.7975 58.5034 56.4072 59.1131 56.4072 59.8652V66.674C56.4072 67.426 55.7975 68.0357 55.0454 68.0357C54.2933 68.0357 53.6837 67.426 53.6837 66.674V59.8652ZM59.1307 59.8652C59.1307 59.1131 59.7404 58.5034 60.4924 58.5034C61.2445 58.5034 61.8542 59.1131 61.8542 59.8652V66.674C61.8542 67.426 61.2445 68.0357 60.4924 68.0357C59.7404 68.0357 59.1307 67.426 59.1307 66.674V59.8652ZM65.9395 59.8652C65.9395 59.1131 66.5491 58.5034 67.3012 58.5034C68.0533 58.5034 68.663 59.1131 68.663 59.8652V66.674C68.663 67.426 68.0533 68.0357 67.3012 68.0357C66.5491 68.0357 65.9395 67.426 65.9395 66.674V59.8652ZM44.1514 53.1908C44.1514 52.2739 44.6694 51.4356 45.4896 51.0255L56.6863 45.4272C57.3678 45.0864 58.17 45.0864 58.8516 45.4272L70.0482 51.0255C70.8684 51.4356 71.3865 52.2739 71.3865 53.1908V54.7208C71.3865 56.0578 70.3026 57.1417 68.9656 57.1417H46.5723C45.2352 57.1417 44.1514 56.0578 44.1514 54.7208V53.1908ZM57.7689 53.0564C58.1301 53.0564 58.4765 52.9129 58.7318 52.6575C58.9872 52.4022 59.1307 52.0558 59.1307 51.6946C59.1307 51.3335 58.9872 50.9871 58.7318 50.7317C58.4765 50.4764 58.1301 50.3329 57.7689 50.3329C57.4078 50.3329 57.0614 50.4764 56.806 50.7317C56.5506 50.9871 56.4072 51.3335 56.4072 51.6946C56.4072 52.0558 56.5506 52.4022 56.806 52.6575C57.0614 52.9129 57.4078 53.0564 57.7689 53.0564Z",
    fill: "#4583FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0047 61.2295C64.7548 61.2295 63.7427 62.2429 63.7427 63.4915V75.1021C63.7427 76.351 64.7558 77.3641 66.0047 77.3641H74.5864C75.8353 77.3641 76.8484 76.351 76.8484 75.1021V69.8016C76.8484 68.867 76.4772 67.9706 75.8163 67.3097C75.1554 66.6489 74.259 66.2776 73.3244 66.2776H72.0624C71.9929 66.2776 71.9262 66.25 71.8771 66.2008C71.828 66.1517 71.8004 66.085 71.8004 66.0156V64.7535C71.8004 63.8189 71.4291 62.9225 70.7682 62.2617C70.1073 61.6008 69.211 61.2295 68.2763 61.2295H66.0047Z",
    fill: "#C1D6FF",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17.125,
    width: 87,
    height: 87,
    rx: 43.5,
    stroke: "url(#paint11_linear_75_6608)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6882 212.625C28.7687 212.625 30.4876 211.062 30.4876 208.495C30.4876 206.531 29.2375 205.147 26.6927 204.857V204.7C28.9696 204.432 29.9518 203.115 29.9518 201.352C29.9518 198.986 28.233 197.669 25.3756 197.669H17.0045V212.625H25.6882ZM19.3931 199.834H25.1078C26.782 199.834 27.5633 200.481 27.5633 201.888C27.5633 203.294 26.715 203.941 25.0408 203.941H19.3931V199.834ZM19.3931 205.928H25.4203C27.1838 205.928 28.0767 206.598 28.0767 208.16C28.0767 209.79 27.2061 210.46 25.4203 210.46H19.3931V205.928ZM35.3081 212.848C37.8306 212.848 39.5941 211.732 40.1745 209.857H40.3308V212.625H42.5408V205.883C42.5408 203.227 40.9558 201.307 37.4288 201.307C33.9018 201.307 31.8034 203.205 31.8034 205.727V205.817H34.192V205.727C34.192 204.098 35.1965 203.428 37.2502 203.428C39.3709 203.428 40.1745 204.075 40.1745 205.906V206.553L35.1295 207.089C32.9419 207.334 31.5579 208.227 31.5579 209.946C31.5579 211.777 33.0089 212.848 35.3081 212.848ZM33.9688 209.79C33.9688 208.919 34.5715 208.629 35.8216 208.473L40.1745 207.982C40.1745 210.169 38.478 211.107 35.9555 211.107C34.5715 211.107 33.9688 210.683 33.9688 209.79ZM47.1037 212.625V197.669H44.6928V212.625H47.1037ZM52.5953 212.848C55.1178 212.848 56.8813 211.732 57.4617 209.857H57.618V212.625H59.828V205.883C59.828 203.227 58.243 201.307 54.716 201.307C51.189 201.307 49.0906 203.205 49.0906 205.727V205.817H51.4792V205.727C51.4792 204.098 52.4837 203.428 54.5374 203.428C56.6581 203.428 57.4617 204.075 57.4617 205.906V206.553L52.4167 207.089C50.2291 207.334 48.8451 208.227 48.8451 209.946C48.8451 211.777 50.2961 212.848 52.5953 212.848ZM51.256 209.79C51.256 208.919 51.8587 208.629 53.1088 208.473L57.4617 207.982C57.4617 210.169 55.7652 211.107 53.2427 211.107C51.8587 211.107 51.256 210.683 51.256 209.79ZM64.3909 212.625V207.134C64.3909 204.723 65.4847 203.473 67.9179 203.473C70.2172 203.473 71.1548 204.522 71.1548 206.598V212.625H73.5656V205.95C73.5656 203.383 72.0477 201.307 68.9671 201.307C66.1544 201.307 64.6811 203.093 64.3463 204.968H64.19V201.53H61.98V212.625H64.3909ZM81.3169 212.848C84.6431 212.848 87.0763 210.973 87.0763 208.205V207.96H84.6877V208.116C84.6877 209.835 83.4376 210.683 81.2723 210.683C78.7721 210.683 77.656 209.477 77.656 207.089C77.656 204.656 78.7721 203.473 81.2723 203.473C83.4376 203.473 84.6877 204.321 84.6877 206.04V206.174H87.0763V205.95C87.0763 203.182 84.6431 201.307 81.3169 201.307C77.656 201.307 75.2674 203.629 75.2674 207.089C75.2674 210.504 77.656 212.848 81.3169 212.848ZM94.4399 212.848C97.7437 212.848 100.065 211.219 100.065 208.852V208.652H97.6544V208.83C97.6544 210.147 96.6945 210.906 94.3729 210.906C91.8058 210.906 90.7566 209.768 90.6673 207.625H100.088C100.155 207.29 100.177 206.977 100.177 206.575C100.177 203.205 97.833 201.307 94.3952 201.307C90.7789 201.307 88.4127 203.629 88.4127 207.089C88.4127 210.795 90.8012 212.848 94.4399 212.848ZM94.3506 203.205C96.7168 203.205 97.8999 204.187 97.8999 206.241V206.285H90.6896C90.8235 204.299 91.895 203.205 94.3506 203.205ZM111.378 212.848C114.682 212.848 117.004 211.219 117.004 208.852V208.652H114.593V208.83C114.593 210.147 113.633 210.906 111.311 210.906C108.744 210.906 107.695 209.768 107.606 207.625H117.026C117.093 207.29 117.115 206.977 117.115 206.575C117.115 203.205 114.771 201.307 111.334 201.307C107.717 201.307 105.351 203.629 105.351 207.089C105.351 210.795 107.74 212.848 111.378 212.848ZM111.289 203.205C113.655 203.205 114.838 204.187 114.838 206.241V206.285H107.628C107.762 204.299 108.833 203.205 111.289 203.205ZM121.332 212.625V207.134C121.332 204.723 122.426 203.473 124.859 203.473C127.158 203.473 128.096 204.522 128.096 206.598V212.625H130.507V205.95C130.507 203.383 128.989 201.307 125.908 201.307C123.095 201.307 121.622 203.093 121.287 204.968H121.131V201.53H118.921V212.625H121.332ZM137.454 212.848C139.954 212.848 141.562 211.531 142.03 209.5H142.097V216.42H144.508V201.53H142.298V204.611H142.097C141.651 202.557 140.088 201.307 137.477 201.307C134.039 201.307 132.097 203.651 132.097 207.089C132.097 210.527 134.017 212.848 137.454 212.848ZM134.53 207.089C134.53 204.41 135.914 203.517 138.236 203.517C140.713 203.517 142.097 204.678 142.097 207.067V207.267C142.097 209.544 140.646 210.661 138.28 210.661C135.892 210.661 134.53 209.745 134.53 207.089ZM151.358 212.848C154.216 212.848 155.689 211.062 156.046 209.187H156.18V212.625H158.39V201.53H156.001V207.022C156.001 209.433 154.863 210.683 152.407 210.683C150.064 210.683 149.104 209.634 149.104 207.558V201.53H146.715V208.205C146.715 210.772 148.233 212.848 151.358 212.848ZM162.991 200.236V197.669H160.58V200.236H162.991ZM162.991 212.625V201.53H160.58V212.625H162.991ZM167.635 212.625V206.397C167.635 204.41 168.416 203.361 170.313 203.361C171.965 203.361 172.635 204.098 172.635 205.683V206.665H175.023V205.214C175.023 203.115 173.93 201.307 171.407 201.307C169.13 201.307 167.925 202.736 167.59 204.522H167.434V201.53H165.224V212.625H167.635ZM178.324 216.42C180.601 216.42 181.851 215.817 182.766 213.83L188.547 201.53H185.891L183.279 207.401L182.23 210.08H182.052L180.958 207.424L178.123 201.53H175.422L180.891 212.625L180.623 213.205C180.288 213.964 179.886 214.232 178.904 214.232H176.739V216.42H178.324Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_6608",
    x1: 18.4658,
    y1: -1.34432,
    x2: 18.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_6608",
    x1: 53.4658,
    y1: -1.34432,
    x2: 53.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_6608",
    x1: 89.4658,
    y1: -1.34432,
    x2: 89.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_6608",
    x1: 125.466,
    y1: -1.34432,
    x2: 125.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_6608",
    x1: 161.466,
    y1: -1.34432,
    x2: 161.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_75_6608",
    x1: 196.466,
    y1: -1.34432,
    x2: 196.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_75_6608",
    x1: 232.466,
    y1: -1.34432,
    x2: 232.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_75_6608",
    x1: 0,
    y1: 19.454,
    x2: 255.154,
    y2: 19.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_75_6608",
    x1: 0,
    y1: 78.454,
    x2: 255.154,
    y2: 78.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_75_6608",
    x1: 0,
    y1: 48.454,
    x2: 255.154,
    y2: 48.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_75_6608",
    x1: 60,
    y1: 16.625,
    x2: 60,
    y2: 104.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_75_6608",
    x1: 60,
    y1: 16.625,
    x2: 60,
    y2: 104.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_6608"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.625,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_75_6608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(39 39.625)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigcontact8);
export default __webpack_public_path__ + "static/media/bigcontact8.03840f145717501364495355d1815b5f.svg";
export { ForwardRef as ReactComponent };